import React, { useEffect } from "react";
import { scroller } from "react-scroll";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Navbar from "../component/navbar";
import HeroSection from "../component/HeroSection";
import Supporters from "../component/Supporters";
import Problem from "../component/Problem";
import HowItWorks from "../component/HowItWorks";
import Products from "../component/Products";
import Success from "../component/Success";
import SentinelWatch from "../component/SentinelWatch";
import Differentiator from "../component/Differentiator";
import Testimonial from "../component/Testimonial";
import Details from "../component/Details";
import Deployment from "../component/Deployment";
import Industries from "../component/Industries";
import About from "../component/About";
import FAQ from "../component/FAQ";
import Contact from "../component/Contact";
import FloatingCTA from "../component/FloatingCTA";
import Footer from "../component/Footer";
import SEOHead from "../component/SEOHead";

export default function Index() {
	const location = useLocation();
	const { t } = useTranslation();

	useEffect(() => {
		if (location.hash) {
			const targetId = location.hash.substring(1);
			scroller.scrollTo(targetId, {
				duration: 500,
				delay: 0,
				smooth: "easeInOutQuart",
			});
		}
	}, [location]);

	const jsonLd = {
		"@context": "https://schema.org",
		"@graph": [
			{
				"@type": "Organization",
				"name": "ANA Labs",
				"url": "https://analabs.tech",
				"logo": "https://analabs.tech/logo512.png",
				"sameAs": [
					"https://linkedin.com/company/ana-labs-technologies",
					"https://instagram.com/analabs.tech",
					"https://x.com/analabss",
					"https://github.com/analabs"
				],
				"description": "ANA Labs builds ANA Sentinel, an AI-powered visual intelligence platform that transforms images and video into structured operational decisions.",
				"contactPoint": {
					"@type": "ContactPoint",
					"telephone": "+598-92-516-901",
					"contactType": "sales",
					"email": "contact@analabs.tech"
				}
			},
			{
				"@type": "LocalBusiness",
				"name": "ANA Labs",
				"address": {
					"@type": "PostalAddress",
					"streetAddress": "Cuareim 1447",
					"addressLocality": "Montevideo",
					"addressCountry": "UY"
				},
				"telephone": "+598-92-516-901",
				"url": "https://analabs.tech"
			},
			{
				"@type": "WebSite",
				"name": "ANA Labs",
				"url": "https://analabs.tech"
			},
			{
				"@type": "Service",
				"name": "ANA Sentinel",
				"provider": {
					"@type": "Organization",
					"name": "ANA Labs"
				},
				"description": "ANA Sentinel analyzes images and video together with operational context and configurable business rules, returning structured, explainable decisions at scale.",
				"areaServed": "Latin America",
				"serviceType": ["Visual Intelligence", "Computer Vision", "Multimodal AI", "Operational Decision Automation"]
			},
			{
				"@type": "BreadcrumbList",
				"itemListElement": [
					{
						"@type": "ListItem",
						"position": 1,
						"name": "Home",
						"item": "https://analabs.tech/"
					}
				]
			}
		]
	};

	return (
		<div>
			<SEOHead
				title={t("SEO.home.title")}
				description={t("SEO.home.description")}
				canonical="https://analabs.tech/"
				jsonLd={jsonLd}
			/>

			<Navbar navdark={false} />

			<HeroSection />

			<Supporters />

			<Problem />

			<HowItWorks />

			<Products />

			<Success />

			<SentinelWatch />

			<Differentiator />

			<Testimonial />

			<Details />

			<Deployment />

			<Industries />

			<About />

			<FAQ />

			<Contact />

			<FloatingCTA />

			<Footer />
		</div>
	);
}
